<template lang="pug">
  .container-outlay.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 账户充值
    c-box(v-loading="loading")
      el-form(:model="$data", label-position="right", label-width="200px")
        el-form-item(label="充值类型")
          el-select(v-model="recharge_type", @change="recharge_amount = 0")
            el-option(v-for="n in 3", :key="n", :value="n", :label="n | recharge_type")
        el-form-item(label="说明") 充值为积力宝、现金券时，资金先充值到营销账户余额中，系统会自动转为积力宝、现金券余额，并通知授权的应用。
        el-form-item(label="充值金额（￥）")
          el-input-number(v-model="recharge_amount")
        el-form-item(label="", v-if="recharge_type === 1") 充值成功后可自行转为积力宝与现金券余额
        el-form-item(label="", v-if="recharge_type === 2") 现金与积力宝兑换比例为 1元 ：1000分
        el-form-item(label="", v-if="recharge_type === 3") 现金券余额用于创建电子现金券
        hr
        h3 请将充值总金额转账到以下银行账户
        el-form-item(label="银行名称") 招商银行股份有限公司广州淘金支行
        el-form-item(label="开户名") 广州市思力智慧互联网科技有限公司
        el-form-item(label="银行卡号") 1209 1024 9410 801
        hr
        el-form-item(label="上传凭证", :required="mchDetail.mch_biz_type !== 2") 转账成功后请上传清晰的转账凭证，支持JPG、PNG文件，最多支持上传9个文件。
        el-form-item(label="提示", v-if="mchDetail.mch_biz_type === 2") 您是内部商家，可不提供转账凭证。
        el-form-item(label="")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="uploadChange")
            el-button(type="primary") 选择文件
        el-form-item(label="", v-loading="uploading", :element-loading-fullscreen="false")
          .img-container(v-if="pic_array.length > 0", v-for="(p, $index) in pic_array")
            .img-delete(@click="deleteImage($index)") ×
            img(:src="p | image", @click="$zoom($options.filters.image(p))").img-thumbnail
          template(v-if="pic_array.length === 0") 未上传任何图片
        hr
        el-form-item(label="备注")
          el-input(v-model="remark")
        el-form-item(label="应用订单号或标识") 直接充值为积力宝及现金券余额时建议填写，以便系统在充值成功后直接通知授权的应用，请与授权的应用方沟通获得。
        el-form-item(label="")
          el-input(v-model="outer_bill_id")
      .align-center
        el-button(type="primary", @click="saveRecharge") 确认充值
</template>

<script>
export default {
  data () {
    return {
      outer_bill_id:    null,
      pic_array:        [],
      recharge_amount:  0,
      recharge_type:    1,
      remark:           null,

      loading:    false,

      uploadURL:  '/mch_web/v1/upload_picture',
      uploading:  false,
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    },
    activityURL () {
      return `/outlay/${this.outlay_account_id}/activity`;
    },
    mchDetail () {
      return this.$store.getters.mchDetail;
    },
  },
  filters: {
    recharge_type (source) {
      switch (source) {
        case 1:   return '营销账户余额';
        case 2:   return '积力宝';
        case 3:   return '现金券余额';
        default:  return source;
      }
    },
  },
  methods: {
    uploadChange (file) {
      const { size } = file;
      if (size < 1 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.uploading = true;
          const result = e.target.result;
          const currentIndex = this.pic_array.length;

          const headlessResult = result.split(',')[1];
          this.$store.dispatch('UPLOAD', headlessResult).then(({ url }) => {
            this.$set(this.pic_array, currentIndex, url);
          }).catch(({ code, msg }) => {
            this.$alert(`转账凭证上传失败。${code}：${msg}`, {
              type:     'error'
            });
          }).finally(() => {
            this.uploading = false;
          });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert('图片上传失败。文件大小超过1MB。', {
          type:     'error'
        });
      }
    },

    deleteImage (index) {
      this.pic_array.splice(index, 1);
    },

    saveRecharge () {
      if (this.mchDetail.mch_biz_type !== 2 && this.pic_array.length === 0) {
        this.$message({
          type:     'warning',
          message:  `请上传至少一张转账凭证图片。`,
        });
        return;
      }
      if (!this.recharge_amount || this.recharge_amount <= 0) {
        this.$message({
          type:     'warning',
          message:  `充值金额应大于 0`,
        });
        return;
      }
      this.loading = true;

      return this.$store.dispatch('APPLY_OUTLAY_ACCOUNT_RECHARGE', {
        outer_bill_id:      this.outer_bill_id,
        outlay_account_id:  this.outlay_account_id,
        pic_urls:           this.pic_array.join(','),
        recharge_amount:    parseInt(this.recharge_amount * 100),
        recharge_type:      this.recharge_type,
        remark:             this.remark,
      }).then(() => {
        this.$alert('充值信息提交成功，请耐心等待平台审批。审批通过后将会通过绑定的手机及邮箱进行通知。', {
          type:     'success',
          showCancelButton:   true,
          cancelButtonText:   '查看详情',
        }).then(() => {
          this.$router.push(this.detailURL);
        }).catch(() => {
          this.$router.push(this.activityURL);
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `余额转换失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
